import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

const RestockCard = () => {
    return (
        <Card
            sx={{
                height: '100%',
                backgroundColor: '#fff',  // white background
                border: 'none',
                borderRadius: 3,
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.05)',
                border: '1px solid #f8bbd0',
                p: 2,
                transition: 'transform 0.3s ease',
                '&:hover': {
                    transform: 'scale(1.01)',
                    boxShadow: '0 12px 24px rgba(0, 0, 0, 0.1)',
                },
            }}
        >
            <CardContent sx={{ p: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <LocalShippingIcon sx={{  mr: 1 }} />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Restock Alerts
                    </Typography>
                </Box>

                <Typography variant="body2" sx={{ fontSize: '0.95rem' }}>
                    • Product: <strong>Blue Jacket</strong><br />
                    • Qty Needed: <strong>120</strong><br />
                    • Last Restock: <strong>10 days ago</strong>
                </Typography>
            </CardContent>
        </Card>
    );
};

export default RestockCard;